import type { SVGProps } from 'react';

const HomeMarkerGray = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 41 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#homeMarkerGray-clip0)">
      <path
        d="M20.3957 0.911743C12.7155 0.911743 6.4895 7.03479 6.4895 14.588C6.4895 25.5289 20.3957 39.2051 20.3957 39.2051C20.3957 39.2051 34.3018 25.5289 34.3018 14.588C34.3018 10.9608 32.8367 7.4822 30.2288 4.91741C27.6209 2.35263 24.0838 0.911743 20.3957 0.911743ZM20.3957 20.0584C17.3236 20.0584 14.8332 17.6092 14.8332 14.588C14.8332 11.5667 17.3236 9.11747 20.3957 9.11747C23.4677 9.11747 25.9581 11.5667 25.9581 14.588C25.9581 16.0388 25.3721 17.4303 24.3289 18.4562C23.2858 19.4821 21.8709 20.0584 20.3957 20.0584Z"
        fill="#596B82"
      />
      <g filter="url(#homeMarkerGray-filter0_d)">
        <path
          d="M27.3734 11.488L21.1373 5.71361C20.6978 5.38944 20.0935 5.38944 19.654 5.71361L13.4178 11.488C13.1393 11.7192 12.9787 12.0595 12.979 12.418V21.578C12.979 22.2494 13.5324 22.7937 14.2151 22.7937H26.5761C27.2588 22.7937 27.8122 22.2494 27.8122 21.578V12.418C27.8125 12.0595 27.652 11.7192 27.3734 11.488Z"
          fill="black"
        />
      </g>
      <path
        d="M27.3734 11.488L21.1373 5.71361C20.6978 5.38944 20.0935 5.38944 19.654 5.71361L13.4178 11.488C13.1393 11.7192 12.9787 12.0595 12.979 12.418V21.578C12.979 22.2494 13.5324 22.7937 14.2151 22.7937H26.5761C27.2588 22.7937 27.8122 22.2494 27.8122 21.578V12.418C27.8125 12.0595 27.652 11.7192 27.3734 11.488Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="homeMarkerGray-filter0_d"
        x="8.979"
        y="3.47048"
        width="22.8332"
        height="25.3232"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <clipPath id="homeMarkerGray-clip0">
        <rect width="41" height="39" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default HomeMarkerGray;
